<template>
    <!-- 商品出库 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'materielOuttoWarehouse')">
            <template slot="header">
                <a-tabs type="card" v-model="tabKey">
                    <a-tab-pane v-model="tabKey" :key="0" tab="其它出库记录" :forceRender="true">
                        <a-form :form="filterForm1" layout="inline" class="store-one-form">
                            <a-form-item label="出库仓库">
                                <a-select :options="warehouseOptions" placeholder="请选择" v-decorator="['warehouseId']"></a-select>
                            </a-form-item>
                            <a-form-item label="申请人">
                                <a-input placeholder="请输入" v-decorator="['applyUserName']"></a-input>
                            </a-form-item>
                            <a-form-item label="申请日期">
                                <a-range-picker v-decorator="['date']" showTime style="width: 100%;"></a-range-picker>
                            </a-form-item>
                            <a-form-item label="出库类型">
                                <a-select placeholder="请选择" v-decorator="['outType']">
                                    <a-select-option value="0">售卖</a-select-option>
                                    <a-select-option value="1">自用</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="审核状态">
                                <a-select placeholder="请选择" v-decorator="['approveState']">
                                    <a-select-option value="0">待审核</a-select-option>
                                    <a-select-option value="1">审核通过</a-select-option>
                                    <a-select-option value="2">审核不通过</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item class="wrap-header-button">
                                <a-button type="primary" @click="search1" :loading="searchLoading1">筛选</a-button>
                                <a-button @click="handleReset1()" :loading="searchLoading1">重置</a-button>
                            </a-form-item>
                        </a-form>
                    </a-tab-pane>
                    <a-tab-pane :key="1" tab="商品销售出库记录" :forceRender="true">
                        <a-form :form="filterForm2" layout="inline" class="store-one-form">
                            <a-form-item label="商品编号">
                                <a-input placeholder="请输入" v-decorator="['goodsNo']"></a-input>
                            </a-form-item>
                            <a-form-item label="商品条形码">
                                <a-input placeholder="请输入" v-decorator="['goodsBarCode']"></a-input>
                            </a-form-item>
                            <a-form-item label="商品名称">
                                <a-input placeholder="请输入" v-decorator="['goodsName']"></a-input>
                            </a-form-item>
                            <a-form-item label="商品分组">
                                <a-select :options="typeOptions" placeholder="请选择" v-decorator="['goodsCategoryId']"></a-select>
                            </a-form-item>
                            <a-form-item label="出库仓库">
                                <a-select :options="warehouseOptions" placeholder="请选择" v-decorator="['warehouseId']"></a-select>
                            </a-form-item>
                            <a-form-item label="出库时间">
                                <a-range-picker v-decorator="['date']" showTime style="width: 100%;"></a-range-picker>
                            </a-form-item>
                            <a-form-item label="客户">
                                <a-input placeholder="请输入" v-decorator="['customerPhone']"></a-input>
                            </a-form-item>
                            <a-form-item label="出库票台">
                                <a-select :options="ticketPlatformOptions" placeholder="请选择" v-decorator="['outTicketPlatform']"></a-select>
                            </a-form-item>
                            <a-form-item class="wrap-header-button">
                                <a-button type="primary" @click="search2" :loading="searchLoading2">筛选</a-button>
                                <a-button @click="handleReset2()" :loading="searchLoading2">重置</a-button>
                            </a-form-item>
                        </a-form>
                    </a-tab-pane>
                </a-tabs>
            </template>
            <div v-show="tabKey === 0" class="wrap-container-in">
                <div class="mb16">
                    <a-button type="primary" @click="goMaterielOuttoWarehouseApply">商品出库申请</a-button>
                </div>
                <a-table
                bordered
                :dataSource="dataSource1"
                :columns="columns1"
                :pagination="pagination1"
                :rowKey="record => record.id"
                :loading="searchLoading1"
                @change="changePage1"
                class="wrap-table"
                >
                    <template slot="empty" slot-scope="key, row, index">
                        {{key || "-"}}
                    </template>
                    <template slot="index" slot-scope="key, row, index">
                        {{index + 1}}
                    </template>
                    <template slot="outState" slot-scope="key, row, index">
                        {{['待出库', '出库成功', '出库失败'][key]}}
                    </template>
                    <template slot="outType" slot-scope="key, row, index">
                        {{['售卖', '自用'][key]}}
                    </template>
                    <template slot="approveState" slot-scope="key, row, index">
                        {{['待审核', '审核通过', '审核不通过'][key]}}
                    </template>
                    <template slot="actions" slot-scope="a,row">
                        <template>
                            <a v-if="true" class="text-primary" @click="showApplyDetail(row)">出库审批单查看</a>
                            <span v-else class="text-disabled">出库审批单查看</span>
                        </template>
                    </template>
                </a-table>
            </div>
            <div v-show="tabKey === 1" class="wrap-container-in">
                <a-table
                bordered
                :dataSource="dataSource2"
                :columns="columns2"
                :pagination="pagination2"
                :rowKey="record => record.id"
                :loading="searchLoading2"
                @change="changePage2"
                class="wrap-table"
                >
                    <template slot="empty" slot-scope="key, row, index">
                        {{key || "-"}}
                    </template>
                </a-table>
            </div>
        </content-view>
        <goods-out-warehouse-apply-detail-modal ref="goodsOutWarehouseApplyDetailModal"></goods-out-warehouse-apply-detail-modal>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import goodsOutWarehouseApplyDetailModal from "@/components/modules/storage/goods-out-warehouse-apply-detail-modal.component";
    const columns1 = [
        {
            title: '序号',
            scopedSlots: {customRender: 'index'}
        },
        {
            title: '出库仓库',
            dataIndex: 'warehouseName'
        },
        {
            title: '申请人',
            dataIndex: 'applyUserName'
        },
        {
            title: '申请时间',
            dataIndex: 'applyTime'
        },
        {
            title: '出库类型',
            dataIndex: 'outType',
            scopedSlots: {customRender: 'outType'}
        },
        {
            title: '出库状态',
            dataIndex: 'state',
            scopedSlots: {customRender: 'outState'}
        },
        {
            title: '审核状态',
            dataIndex: 'approveState',
            scopedSlots: {customRender: 'approveState'}
        },
        {
            title: '审核人',
            dataIndex: 'approvalUserName'
        },
        {
            title: '审核时间',
            dataIndex: 'approvalTime',
            scopedSlots: { customRender: 'empty' }
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'actions' }
        }
    ];
    const columns2 = [
        {
            title: '商品编号',
            dataIndex: 'goodsNo'
        },
        {
            title: '商品条形码',
            dataIndex: 'goodsBarCode',
            scopedSlots: { customRender: 'empty' }
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification'
        },
        {
            title: '商品分组',
            dataIndex: 'goodsCategoryName'
        },
        {
            title: '出库仓库',
            dataIndex: 'warehouseName'
        },
        {
            title: '出库数量',
            dataIndex: 'outNum'
        },
        {
            title: '出库时间',
            dataIndex: 'outTime'
        },
        {
            title: '客户',
            dataIndex: 'customerPhone'
        },
        {
            title: '出库票台',
            dataIndex: 'outTicketPlatformName'
        },
        {
            title: '操作人',
            dataIndex: 'applyUserName'
        },
    ];
    export default {
        name: 'materielOuttoWarehouse',
        components: {
            goodsOutWarehouseApplyDetailModal
        },
        props: {},
        data() {
            return {
                columns1,
                columns2,
                dataSource1: [],
                dataSource2: [],
                pagination1: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                pagination2: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                warehouseOptions: [],
                ticketPlatformOptions: [],
                typeOptions: [],
                tabKey: 0,
                searchLoading1: false,
                searchLoading2: false
            };
        },
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            changePage1(page) {
                this.pagination1.pageSize = page.pageSize;
                this.pagination1.current = page.current;
                this.selfGoodsOtherOutRecord();
            },
            // 重置筛选
            handleReset1() {
                this.filterForm1.resetFields();
                this.search1();
            },
            search1() {
                this.pagination1.current = 1;
                this.selfGoodsOtherOutRecord();
            },
            changePage2(page) {
                this.pagination2.pageSize = page.pageSize;
                this.pagination2.current = page.current;
                this.selfGoodsSalesOutRecord();
            },
            // 重置筛选
            handleReset2() {
                this.filterForm2.resetFields();
                this.search2();
            },
            search2() {
                this.pagination2.current = 1;
                this.selfGoodsSalesOutRecord();
            },
            /**
             * @goMaterielOuttoWarehouseApply 跳转到商品出库审批
             */
            goMaterielOuttoWarehouseApply() {
                this.$router.push({name: 'materielOuttoWarehouseApply'})
            },
            /**
             * @getWarehouseList 获取门店下仓库列表
             */
            getWarehouseList() {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.selfWarehousePage({
                    body: {
                        shopId: this.shopId,
                        pageNum: 1,
                        pageSize: 999999
                    }
                }).then(res => {
                    if (res && res.data) {
                        res.data.forEach(item => {
                            item.label = item.warehouseName;
                            item.value = item.id;
                        });
                        this.warehouseOptions = res.data;
                    }
                });
            },
            /**
             * @selfGoodsOtherOutRecord 其它出库记录
             */
            selfGoodsOtherOutRecord() {
                if (this.searchLoading1 || !this.shopId) {
                    return false;
                }
                this.filterForm1.validateFields((errors, values) => {
                    if (errors) return;
                    if (Boolean(values.date) && Boolean(values.date.length)) {
                        values.applyTimeStart = values.date[0].format('YYYY-MM-DD HH:mm:ss');
                        values.applyTimeEnd = values.date[1].format('YYYY-MM-DD HH:mm:ss');
                    }
                    delete values.date;
                    this.searchLoading1 = true;
                    this.$api.newStorage.selfGoodsOtherOut({
                        body: {
                            ...values,
                            pageNum: this.pagination1.current,
                            pageSize: this.pagination1.pageSize,
                            shopId: this.shopId
                        }
                    }).then(res => {
                        res.data.forEach(item => {
                            item.businessId = item.id;
                        });
                        this.searchLoading1 = false;
                        if (Boolean(res) && Boolean(res.data)) {
                            this.dataSource1 = res.data;
                        }
                        this.pagination1.total = res.total;
                    }).catch(err => {
                        this.searchLoading1 = false;
                    });
                })
            },
            /**
             * @selfGoodsSalesOutRecord 商品销售出库记录
             */
            selfGoodsSalesOutRecord() {
                if (this.searchLoading2 || !this.shopId) {
                    return false;
                }
                this.filterForm2.validateFields((errors, values) => {
                    if (errors) return;
                    if (Boolean(values.date) && Boolean(values.date.length)) {
                        values.outTimeStart = values.date[0].format('YYYY-MM-DD HH:mm:ss');
                        values.outTimeEnd = values.date[1].format('YYYY-MM-DD HH:mm:ss');
                    }
                    delete values.date;
                    this.searchLoading2 = true;
                    this.$api.newStorage.selfGoodsSalesOut({
                        body: {
                            ...values,
                            pageNum: this.pagination2.current,
                            pageSize: this.pagination2.pageSize,
                            shopId: this.shopId
                        }
                    }).then(res => {
                        res.data.forEach(item => {
                            item.businessId = item.id;
                        });
                        this.searchLoading2 = false;
                        if (Boolean(res) && Boolean(res.data)) {
                            this.dataSource2 = res.data;
                        }
                        this.pagination2.total = res.total;
                    }).catch(err => {
                        this.searchLoading2 = false;
                    });
                })
            },
            /**
             * @cashPayPlatform 获取门店下票台列表
             */
            cashPayPlatform() {
                if (!this.shopId) {
                    return false;
                }
                this.$api.ticketDesk.cashPayPlatform({
                    body: {
                        pageNum: 1,
                        pageSize: 999999,
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (res && res.data) {
                        res.data.forEach(item => {
                            item.label = item.name;
                            item.value = item.id;
                        });
                        this.ticketPlatformOptions = res.data;
                    }
                })
            },
            /**
             * @getGoodsCateList 获取商品类别
             */
            getGoodsCateList() {
                this.$api.newStorage.getSelfGoodsCateList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        res.forEach(item => {
                            item.label = item.categoryName;
                            item.value = item.id;
                        });
                        this.typeOptions = res;
                    }
                });
            },
            /**
             * @showApplyDetail 出库审批单查看
             */
            showApplyDetail(row) {
                this.$refs.goodsOutWarehouseApplyDetailModal.showApplyDetail(row);
            }
        },
        beforeCreate() {
            this.filterForm1 = this.$form.createForm(this);
            this.filterForm2 = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getWarehouseList();
            this.getGoodsCateList();
            this.cashPayPlatform();
            this.selfGoodsOtherOutRecord();
            this.selfGoodsSalesOutRecord();
        },
        watch: {
            '$route'(val) {
                val.name == 'materielOuttoWarehouse' && this.selfGoodsOtherOutRecord();
            },
            'shopId'() {
                this.pagination1.current = 1;
                this.pagination2.current = 1;
                this.getWarehouseList();
                this.getGoodsCateList();
                this.cashPayPlatform();
                this.selfGoodsOtherOutRecord();
                this.selfGoodsSalesOutRecord();
            }
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
</style>
